import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UserManagementComponent } from './components/user-management/user-management.component';
import { TreeCardComponent } from './components/user-management/tree-card/tree-card.component';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTreeModule } from '@angular/material/tree';
import { QuotesInstructionsComponent } from './components/documentation-component/quotes-instructions/quotes-instructions.component';
import { ComparisonInstructionsComponent } from './components/documentation-component/comparison-instructions/comparison-instructions.component';

@NgModule({
  declarations: [
    UserManagementComponent,
    TreeCardComponent,
    QuotesInstructionsComponent,
    ComparisonInstructionsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatIconModule,
    MatCheckboxModule,
    MatTreeModule
  ],
  exports: [
    UserManagementComponent,
    QuotesInstructionsComponent,
    ComparisonInstructionsComponent
  ]
})
export class UserModule { }
